export enum CustomizationStep {
  PREFERENCES = 'PREFERENCES',
  PROCESSING = 'PROCESSING',
  REVIEW = 'REVIEW',
  PREVIEW = 'PREVIEW',
  TRANSLATION = 'TRANSLATION',
  COMPLETE = 'COMPLETE',
}
